type Vec3 = [number, number, number];

export const TRUCK_Y = -0.55;
export const barZ = 0.675;
export const SERVICE_X = -0.8;

const FESTOON_HALF_SPAN = 0.72;
const FESTOON_Y = 1.6;
const FESTOON_SAG = 0.07;
const FESTOON_Z = barZ + 0.14;
const BULB_COUNT = 8;
const BULB_DROP = 0.045;

export function festoonPoint(t: number): Vec3 {
  return [SERVICE_X - FESTOON_HALF_SPAN + 2 * FESTOON_HALF_SPAN * t, FESTOON_Y - Math.sin(t * Math.PI) * FESTOON_SAG, FESTOON_Z];
}

export const BULB_POSITIONS: Vec3[] = Array.from({ length: BULB_COUNT }, (_, i) => {
  const [x, y, z] = festoonPoint((i + 1) / (BULB_COUNT + 1));
  return [x, y - BULB_DROP, z];
});

export const HEADLIGHT_POSITION: Vec3 = [1.556, 0.62, 0];
